export const aboutData = {
  brandName: '亚洲精品视频',
  tagline: '汇聚亚洲精彩，品味影像之美',
  introduction: '亚洲精品视频致力于打造亚洲领先的高品质影视内容平台，汇聚来自中国、日本、韩国、印度、泰国等亚洲各地的优质电影、电视剧、纪录片、短片、动漫及综艺节目，为全球用户提供流畅高清的正版视频观看体验。',
  mission: '我们的使命是让每一位用户都能轻松发现和欣赏来自亚洲各国的精彩影视作品，通过影像搭建文化交流的桥梁，促进亚洲多元文化的传播与理解。',
  vision: '成为全球最具影响力的亚洲影视内容聚合平台，让亚洲故事走向世界。',
  stats: [
    { value: '2000+', label: '精选内容' },
    { value: '15+', label: '覆盖国家/地区' },
    { value: '500万+', label: '活跃用户' },
    { value: '99.9%', label: '服务可用率' },
  ],
  features: [
    {
      icon: 'ri-4k-line',
      title: '超高清画质',
      description: '提供4K超高清正版内容，带给您身临其境的观影体验',
    },
    {
      icon: 'ri-global-line',
      title: '亚洲全覆蓋',
      description: '覆盖中日韩印东南亚等15+个国家和地区的内容资源',
    },
    {
      icon: 'ri-translate-2',
      title: '多语言字幕',
      description: '支持中文、英文、日文、韩文等多语种字幕，无障碍欣赏',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端同步',
      description: '支持手机、平板、电脑、电视全终端同步观看，随时随地',
    },
    {
      icon: 'ri-heart-line',
      title: '智能推荐',
      description: '基于AI算法的个性化推荐系统，精准匹配您的观影喜好',
    },
    {
      icon: 'ri-shield-check-line',
      title: '正版保障',
      description: '所有内容均获得正版授权，为用户提供安全合法的观看体验',
    },
  ],
  contact: {
    address: '北京市朝阳区建国路88号SOHO现代城A座18层',
    phone: '400-888-0000',
    email: 'contact@asianpremiumvideo.com',
    wechat: 'AsianPremiumVideo',
    weibo: '@亚洲精品视频',
  },
  faqs: [
    {
      question: '亚洲精品视频是否需要付费？',
      answer: '我们提供免费内容和会员专享内容两种模式。注册即享基础免费内容，开通会员可观看全部精选内容并享受超高清画质。',
    },
    {
      question: '支持哪些设备观看？',
      answer: '支持网页端、iOS、Android手机及平板、智能电视（包括小米电视、华为智慧屏等主流品牌）、Apple TV等全终端观看。',
    },
    {
      question: '视频内容是否都有中文字幕？',
      answer: '是的，所有非中文内容均配备专业翻译的中文字幕。部分热门内容还提供简繁双语字幕及多语种字幕选择。',
    },
    {
      question: '如何成为内容创作者？',
      answer: '我们欢迎优秀的内容创作者加入平台。请通过联系邮箱发送您的作品信息和联系方式，我们的内容团队会尽快与您联系。',
    },
    {
      question: '会员可以同时在几个设备上使用？',
      answer: '标准会员支持2个设备同时在线观看，高级会员支持4个设备同时在线，家庭会员支持6个设备同时在线。',
    },
    {
      question: '如何取消自动续费？',
      answer: '您可以在"个人中心-会员管理"中随时取消自动续费，取消后会员权益将持续到当前付费周期结束。',
    },
  ],
};